<template>
  <div class="existing-files row">
    <div class="file" v-for="file in files" :key="file.id">
      <div class="file-icon">
        <div v-if="file.thumbnail && thumbnails[file.id] !== false" class="thumbnail">

          <div
            v-if="thumbnails[file.id] === 'error'"
            style="width: 80px; height: 100px; border: 1px solid;"
          >
            <font-awesome-icon
              icon="times"
            ></font-awesome-icon>
          </div>
          <font-awesome-icon
            icon="spinner"
            :spin="true"
            v-else-if="thumbnails[file.id] === null"
          ></font-awesome-icon>
          <img v-else-if="typeof thumbnails[file.id] === 'string'" :src="thumbnails[file.id]" width="80px" />
        </div>
        <font-awesome-icon
          :icon="fileIcon"
          size="4x"
          v-else
        ></font-awesome-icon>
      </div>
      <div class="action-row">
        <font-awesome-icon
          :icon="downloadIcon"
          @click="downloadFile(file)"
          v-if="!file.temporary"
        ></font-awesome-icon>
        <font-awesome-icon
          :icon="closeIcon"
          @click="selectForDeletion(file)"
          v-if="Boolean(disabled) === false"
        ></font-awesome-icon>
      </div>
      <div class="file-name">
        {{ file.original_filename || file.name }}
      </div>
    </div>
    <modal
      v-if="showFileDeleteModal"
      :isConfirm="true"
      confirmText="Confirm Delete"
      modalWidth="400px"
      @close="showFileDeleteModal = false"
      @confirmed="deleteSelectedFile"
    >
      <span slot="header">Delete File</span>
      <div slot="body" id="measure-delete-dialog-text">
        Are you sure you want to delete this file?
      </div>
    </modal>
  </div>
</template>
<script>
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faFile, faDownload, faTimes } from "@fortawesome/free-solid-svg-icons";
export default {
  inject: {
    apiClient: {
      default() {
        return axios;
      }
    },
    formHasJsonApi: {
      default() {
        return false;
      }
    }
  },

  props: ["files", "disabled"],

  components: {
    FontAwesomeIcon
  },

  data() {
    return {
      thumbnails: {},
      showFileDeleteModal: false,
      deleteFile: {},
      fileIcon: faFile,
      downloadIcon: faDownload,
      closeIcon: faTimes
    };
  },

  mounted() {
    this.getThumbnailsForFiles();
  },

  methods: {
    async downloadFile(file) {

      const urlResponse = await this.apiClient.get('/api/signed-download-url/' + file.id);

      if(!urlResponse.data.meta.url) {
        throw new Error("Invalid url to open");
      }

      window.open(urlResponse.data.meta.url);
    },
    async getThumbnailsForFiles() {

      this.files.forEach(file => {

        if(!file.thumbnail) {
          this.$set(this.thumbnails, file.id, false);
          return;
        }

        this.$set(this.thumbnails, file.id, null);

        this.apiClient.get('/api/files/' + file.id + '/thumbnail').then(response => {
          let thumbnailUrl;
          if(this.formHasJsonApi) {
            thumbnailUrl = response.data.meta.url;
          } else {
            thumbnailUrl = response.data;
          }
          this.$set(this.thumbnails, file.id, thumbnailUrl);
        }).catch(error => {
          console.log(error);
          this.$set(this.thumbnails, file.id, 'error');
        });
      });
    },
    selectForDeletion(file) {
      this.deleteFile = file;
      this.showFileDeleteModal = true;
    },
    deleteSelectedFile() {
      if (this.disabled === 1) {
        return;
      } else if (this.deleteFile.temporary) {
        this.$emit('removeTemporaryFile', this.deleteFile);
        this.deleteFile = {};
        this.showFileDeleteModal = false;
        return;
      }

      this.showFileDeleteModal = false;
      this.apiClient
        .delete("/api/files/" + this.deleteFile.id)
        .then(() => {
          this.$emit("deletedFile", this.deleteFile);
          this.deleteFile = {};
          window.notify.message("Successfully deleted file", "success");
        })
        .catch(error => {
          window.notify.apiError(error);
        });
    }
  }
};
</script>
